import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import MasterContentSection from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/Settings/MasterContentSection';

const ContentSettingsInnerPage = () => {
  return (
    <Flex flexDirection="column" gap={48}>
      <MasterContentSection />
    </Flex>
  );
};

export default ContentSettingsInnerPage;
